import { Date } from "core-js";

export default {
  SET_RENT_LIST(state, item){
    state.rentList = item;
  },
  APPLY_RENT_FILTER(state, item) {
    state.rentFilter[item.group] = item.value;
  },
  RESET_RENT_FILTER(state) {
    state.rentFilter = {
      filter_style: "all",
      filter_campus: {},
      filter_blocks: {}
    };
    state.rentSearchQuery = "";
  },
  SET_RENT_SEARCH_QUERY(state, query) {
    state.rentSearchQuery = query;
  },
  APPLY_RENT_FILTER_TOGGLE(state, item) {
    state.rentFilter[item.group] = Object.assign(
      {},
      state.rentFilter[item.group],
      { [item.value]: item.isSelected }
    );
    state.rentFilter = Object.assign({}, state.rentFilter); 
  },
  SET_REFINE(state, value) {
    state.canRefine = value;

    if (
      state.rentFilter.filter_style == "all" &&
      (!Object.keys(state.rentFilter.filter_campus).some(function(key) {
        return state.rentFilter.filter_campus[key] == true;
      }) &&
        !Object.keys(state.rentFilter.filter_blocks).some(function(key) {
          return state.rentFilter.filter_blocks[key] == true;
        }))
    )
      state.canRefine = false;
  },
  SOLD_POINTER(state, item){
    state.rentList.forEach(el => {
      if (el.PointerID == item.PointerID){
        el.PointerState = item.RentState;
        el.SoldInfo = item;
        return;
      }
    });
  },
  SOLD_AUTH_POINTER(state, item){  
    state.rezAreaList.forEach(el => {
      if (el.RentID == item.RentID){
        el.RentState = item.RentState;
      }
    }); 
  },
  ADD_AUTH_POINTER(state, item){ 
    state.rezAreaList.push(item);
  },
  SET_AUTH_POINTER(state, query){
    state.rezAreaList = Array.prototype.concat([], query); 
  }
};
